import { GET, POST } from "../APiHelper/API";

export const getAvailableCupsAndSeasonsOptionsAPICall = (
  onSuccess,
  onError
) => {
  GET(`/api/v1/user_notifications/options`, onSuccess, onError);
};

export const getSubscribedCupsAndSeasonsOptionsAPICall = (
  onSuccess,
  onError
) => {
  GET(`/api/v1/user_notifications/subscriptions`, onSuccess, onError);
};

export const subscribeCupsAndSeasonsOptionsAPICall = (
  data,
  onSuccess,
  onError
) => {
  POST(`/api/v1/user_notifications/subscribe`, data, onSuccess, onError);
};
export const unsubscribeCupsAndSeasonsOptionsAPICall = (
  data,
  onSuccess,
  onError
) => {
  POST(`/api/v1/user_notifications/unsubscribe`, data, onSuccess, onError);
};
export const getCupsAndSeasonsNotificationsAPICall = (
  page,
  onSuccess,
  onError
) => {
  GET(
    `/api/v1/user_notifications/notifications?page=${page}`,
    onSuccess,
    onError
  );
};

export const markAsReadNotificationAPICAll = (ids, onSuccess, onError) => {
  let data = {
    ids: ids,
  };
  POST(`/api/v1/user_notifications/mark_as_read`, data, onSuccess, onError);
};
export const markGameAsReadAPICall = (data, onSuccess, onError) => {
  POST(`/api/v1/games/mark_game_as_read`, data, onSuccess, onError);
};
